/**
 * @file Defines the {@link ConsoleManager} classs
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** Class for managing desktop console */
 export class ConsoleManager {

    /**
     * Reference to autoplay interface container
     * @memberof ConsoleManager
     * @protected
     * @instance
     * @type {HTMLElement}
     */
    _autoplay
    
    /**
     * Reference to bet interface container
     * @memberof ConsoleManager
     * @protected
     * @instance
     * @type {HTMLElement}
     */
    _bet

    /**
     * Font size config for elements of console
     * @memberof ConsoleManager
     * @protected
     * @instance
     * @type {console-font-size-config}
     */
    _fontSizeConfig

    /**
     * Initialize console manager
     */
    constructor() {

        //Initialise font size config
        this._fontSizeConfig = {

            //Autoplay config
            autoplay: {

                'betMaxBox': {
                    'de':   18
                }

            }

        }

        this._autoplay = document.getElementById('autoPlaySettings')    //Store autoplay interface container node
        this._bet      = document.getElementById('betValueContainer')   //Store bet interface container node
        this.autoplayInterface()                                        //Update autoplay interface
        this.betInterface()                                             //Update bet interface
        this.fontSize()                                                 //Adjust font sizes

    }

    /**
     * Updates an interface with arrows to represent increasing/decreasing a value
     * @param {object} e_ - Node to update with left & right arrows
     */
    arrows(e_) {

        //Initialise sides for HTML entites used for bet amount selectors
        let sides = {

            left:  'l',
            right: 'r'

        }

        //Loop through bet value node children
        for (let i = 0; i < e_.children.length; i++) {

            let c = e_.children[i] //Store current child

            //If node is bet amount selector
            if (c.classList.contains('side__box')) {

                let s = c.classList[0].replace(/box__/g,'') //Generate key to access sides object
                c.innerHTML = `&${sides[s]}trif;`           //Produce corresponding HTML entity for bet selector

            }

        }

    }

    /** Handles updating autoplay interface */
    autoplayInterface() {

        let inputs = document.getElementsByClassName('auto__input')              //Retrieve all auto input nodes
        Array.from(inputs).forEach(v_ => v_.setAttribute('autocomplete', 'off')) //Turn off autocomplete

        let settings = this._autoplay.querySelectorAll('ul')[0] //Retrieve autoplay settings

        //Loop through autoplay settings
        for (let i = 0; i < settings.children.length; i++) {

            let s       = settings.children[i]                    //Store current setting
            let l       = document.createElement('label')         //Create label
            l.innerHTML = balanceManager_.geBalanceObj().currency //Store currency symbol

            //Add currency symbol where setting includes input field
            Array.from(s.children).forEach(v_ => v_.nodeName === 'INPUT' && s.insertBefore(l, s.children[2]))

        }

        let value = this._autoplay.children[1] //Store autoplay value node
        this.arrows(value)                     //Update autoplay interface with arrows to increase/decrease autoplay amount

    }

    /** Handles updating bet interface */
    betInterface() {

        let value = this._bet.children[2]                                           //Store bet value node
        this.arrows(value)                                                          //Update bet interface with arrows to increase/decrease bet amount
        let cashOptions = document.getElementsByClassName('cash__options__list')[0] //Store reference to cash options in bet interface

        //Loop through cash options children
        for (let i = 0; i < cashOptions.children.length; i++) {

            //Create div to store label text
            let div = document.createElement('div')
            div.classList.add(`bet-col-1`)
        
            let li = cashOptions.children[i] //Store reference to cash option li element
            li.appendChild(div)              //Add div to li element

            let label       = li.children[0]                //Store reference to cash option label
            label.innerHTML = Translate.do(label.innerHTML) //Translate label value
            let button      = li.children[1]                //Store reference cash option button

            div.appendChild(label) //Add label to first column div

            //Create div to store button to toggle option
            let div2 = document.createElement('div')
            div2.classList.add(`bet-col-2`)

            li.appendChild(div2) //Add second column div to li element

            div2.appendChild(button) //Add button to second column div
        
        }

    }

    /** Adjust font size based on language */
    fontSize() {

        let { autoplay }    = this._fontSizeConfig  //Destucture font size config

        //Loop through autoplay config
        for (let id in autoplay) {

            let elem    = document.getElementById(id)   //Store element from config
            let font    = autoplay[id][gameParams.lang] //Store font config

            //Add font config is one exists for that language
            font && Array.from(elem.children).map(v_ => v_.style.fontSize = `${font}px`)

        }

    }

 }